import { render, staticRenderFns } from "./ValidationComponent.vue?vue&type=template&id=761ad22e&"
import script from "./ValidationComponent.vue?vue&type=script&lang=js&"
export * from "./ValidationComponent.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports